import React from 'react'
import { Box, Typography, IconButton } from '@mui/material'
import { FilterAlt as FilterAltIcon } from '@mui/icons-material'

export interface FilterableColumnHeaderProps {
  field: string
  label: string
  isFiltered: boolean
  onToggleMenu: () => void
}

export const FilterableColumnHeader: React.FC<FilterableColumnHeaderProps> = ({
  label,
  isFiltered,
  onToggleMenu,
}) => {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        maxWidth: '100%',
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontWeight: 600,
          fontSize: '0.875rem',
          color: 'inherit',
        }}
      >
        {label}
      </Typography>
      {isFiltered && (
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation()
            onToggleMenu()
          }}
          sx={{
            p: 0.25,
            color: 'action.active',
            '&:hover': {
              backgroundColor: 'action.hover',
            },
          }}
          aria-label={`${label} filter active`}
        >
          <FilterAltIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  )
}

export default FilterableColumnHeader
